import React, { useMemo } from 'react';

import * as Styled from 'shiftNotes/styles/NoteCaptureRecording.style';

const WAVEFORM_BAR_COUNT = 40;
const MIN_BAR_HEIGHT = 3;
const MAX_BAR_HEIGHT = 40;

interface WaveformProps {
  audioLevel: number;
  isAnimating: boolean;
}

export default function Waveform({
  audioLevel,
  isAnimating,
}: WaveformProps): JSX.Element {
  const heights = useMemo(() => {
    if (!isAnimating) {
      return Array(WAVEFORM_BAR_COUNT).fill(MIN_BAR_HEIGHT);
    }
    return Array.from({ length: WAVEFORM_BAR_COUNT }, (_, index) => {
      const baseVariation = Math.sin(
        (index / WAVEFORM_BAR_COUNT) * Math.PI * 3
      );
      const noise = Math.sin(index * 12.9898) * 43758.5453;
      const pseudoRandom = noise - Math.floor(noise);
      const randomFactor = 0.5 + pseudoRandom * 0.5;
      const height =
        MIN_BAR_HEIGHT +
        (MAX_BAR_HEIGHT - MIN_BAR_HEIGHT) *
          (0.3 + Math.abs(baseVariation) * 0.7) *
          randomFactor *
          audioLevel;
      return Math.round(height);
    });
  }, [audioLevel, isAnimating]);

  return (
    <Styled.WaveformContainer>
      {heights.map((height, index) => (
        <Styled.WaveformBar
          key={index}
          $height={height}
          $delay={index * 0.05}
          $isAnimating={isAnimating}
        />
      ))}
    </Styled.WaveformContainer>
  );
}
